import { z } from 'zod';
import { httpClient } from '@/shared/api/httpClient';
import { readApiEnvelopeData } from '@/shared/api/response';
/** 上传素材接口返回的 OSS 地址结构，与后端 AssetUploadVO 对齐。 */
const coverUploadResponseSchema = z.object({ url: z.string().min(1) });
/**
 * 上传项目封面：把本地封面图片的 dataURL 提交后端上传素材接口转存阿里云 OSS，返回访问 URL。
 * 只在用户提交表单（创建项目或保存编辑）时调用，dataURL 仅作传输载体，表单与落库都只保留 OSS URL。
 * @param dataUrl 本地封面图片的 dataURL。
 * @returns 阿里云 OSS 访问 URL。
 */
export async function uploadProjectCover(dataUrl) {
    const response = await httpClient.post('/asset/upload', { kind: 'image', dataUrl });
    return coverUploadResponseSchema.parse(readApiEnvelopeData(response)).url;
}
